export default "__VITE_ASSET__GvJ0$4td__"